export default __webpack_public_path__ + "static/media/kotlin.22a89dcc.svg";